import { render, staticRenderFns } from "./closedticket.vue?vue&type=template&id=47f610a3&"
import script from "./closedticket.vue?vue&type=script&lang=js&"
export * from "./closedticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports